<template>
    <basic-container>
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :search.sync="searchForm"
                   :page="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @refresh-change="onLoad"
                   @on-load="onLoad">


          <template slot="projectIdSearch" slot-scope="scope">
            <el-select
              v-model="query.projectId"
              placeholder="请选择项目名称"
              style="width: 100%"
              @change="(value)=>projectChange(value)"
            >
              <el-option
                v-for="item in projectList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </template>

          <template slot="projectIdForm" slot-scope="scope">
            <el-select
              :disabled='editMode'
              v-model="form.projectId"
              placeholder="请选择项目名称"
              style="width: 100%"
              @change="(value)=>projectChange_(value)"
            >
              <el-option
                v-for="item in projectList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </template>

          <template slot="departmentIdForm" slot-scope="scope">
            <div style="width:100%">
              <avue-input-tree :disabled="!deptNameFlag"
                               style="width:100%"
                               :props='treeDeptProps'
                               v-model="form.departmentId"
                               placeholder="请选择所属部门"
                               type="tree"
                               :dic="deptList">
              </avue-input-tree>
            </div>

          </template>
          <template slot="departmentIdSearch" slot-scope="scope">
            <avue-input-tree :disabled=false
                             style="width:100%"
                             :props='treeDeptProps'
                             v-model="query.departmentId"
                             placeholder="请选择所属部门"
                             type="tree"
                             :dic="deptList">
            </avue-input-tree>
          </template>

          <template slot="fileAttachForm" slot-scope="scope">
            <vUpload :max="5242880" :limit="10" :fileList.sync="form.fileAttach" :disabled="disabled"></vUpload>
          </template>
<!--          v-if="permission.logisticsPersonalFile_delete"-->
          <template slot="menuLeft">
                <el-button type="danger"
                           size="small"
                           icon="el-icon-delete"
                           plain
                           @click="handleDelete">删 除
                </el-button>
            </template>
        </avue-crud>
    </basic-container>
</template>

<script>
    import {add, getDetail, getList, remove, update} from "@/api/crmedical/value/logistics-personal-file/logisticsPersonalFile";
    import {getProjectDept, treeByProjectDeptId} from "@/api/crmedical/device/device";
    import vUpload from "@/views/components/v-upload";
    import {getProjectList} from "@/api/crmedical/project/project";
    import {mapGetters} from "vuex";
    import qrcodeDownload from "../../device/device/qrcode-download";

    export default {
      components: {
        vUpload
      },
        data() {
            return {
              editMode:false,
              deptNameFlag:false,
              firstDisplayFlag:false,
              treeDeptProps: {
                labelText: '标题',
                label: 'title',
                value: 'id',
                children: 'children',
              },
              projectList:[],
              deptList:[],
              form: {
                departmentId:'',
                fileAttach:[],
              },
              query: {
                projectId:'',
                name:'',
                departmentId:'',
                workStatus:''
              },
              loading: true,
              page: {
                  pageSize: 10,
                  currentPage: 1,
                  total: 0
              },
              selectionList: [],
              option: {
                  indexLabel:"序号",
                  menu: true,
                  height: 'auto',
                  calcHeight: 30,
                  tip: false,
                  searchShow: true,
                  addBtn: true,
                  delBtn: true,
                  // searchBtn: false,
                  // emptyBtn: false,
                  searchMenuSpan: 4,
                  border: true,
                  index: true,
                  viewBtn: true,
                  selection: true,
                  dialogClickModal: false,
                  column: [
                    {
                      label: "项目名称",
                      prop: "projectName",
                      search: false,
                      viewDisplay:false,
                      addDisplay:false,
                      editDisplay:false,
                    },
                    {
                      label: "项目名称",
                      prop: "projectId",
                      hide:true,
                      span:12,
                      search:true,
                      searchslot:true,
                      searchSpan:5,
                      formslot:true,
                      rules: [{
                        required: true,
                        message: "请选择项目",
                        trigger: "blur"
                      }]
                    },
                    /*{
                      label: "项目名称",
                      // editDisabled: true,
                      prop: "projectId",
                      type: 'select',
                      // cascaderItem: ['departmentId'],
                      searchClearable:false,
                      search: true,
                      searchSpan:5,
                      dicUrl: 'api/v4ward/project/getProjectList',
                      props: { label: 'name', value: 'id' },
                      rules: [{
                        required: true,
                        message: "请选择项目名称",
                        trigger: "change"
                      }]
                    },*/
                    {
                      label: "部门",
                      prop: "deptName",
                      search: false,
                      viewDisplay:false,
                      addDisplay:false,
                      editDisplay:false,
                    },
                    {
                      label: "部门",
                      prop: "departmentId",
                      hide:true,
                      span:12,
                      search:true,
                      searchslot:true,
                      searchSpan:5,
                      formslot:true,
                      rules: [{
                        required: true,
                        message: "请选择部门",
                        trigger: "blur"
                      }]
                    },
                    /*{
                      label: "部门",
                      search: true,
                      searchSpan:5,
                      prop: "departmentId",
                      type:'tree',
                      dicUrl: 'api/v4ward/dept/treeByProjectDeptId?projectId={{key}}',
                      props: {
                        label: 'title',
                        value: 'id',
                      },
                      rules: [{
                        required: true,
                        message: "请选择部门",
                        trigger: "blur"
                      }],
                    },*/
                        {
                          label: "岗位",
                          prop: "post",
                          maxlength: 30,
                          showWordLimit: true,
                          overHidden: true,
                          rules: [{
                              required: true,
                              message: "请输入岗位",
                              trigger: "change"
                          }]
                        },
                        {
                          label: "姓名",
                          prop: "name",
                          search:true,
                          searchSpan:5,
                          maxlength: 30,
                          showWordLimit: true,
                          overHidden: true,
                          rules: [{
                              required: true,
                              message: "请输入",
                              trigger: "change"
                          }]
                        },
                        {
                          label: "出生年月",
                          prop: "birthday",
                          type: 'date',
                          format: 'yyyy-MM-dd',
                          valueFormat: 'yyyy-MM-dd',
                          pickerOptions: {
                            disabledDate(time) {
                              return time.getTime() > Date.now();
                            }
                          },
                          rules: [{
                              required: true,
                              message: "请选择出生年月",
                              trigger: "change"
                          }]
                        },
                        {
                          label: "性别",
                          prop: "sex",
                          type: 'select',
                          dataType: 'number',
                          props: {
                            label: 'dictValue',
                            value: 'dictKey',
                          },
                          dicUrl: '/api/blade-system/dict/dictionaryWithIntKey?code=sex',
                          rules: [{
                            required: true,
                            message: "请选择",
                            trigger: "change"
                          }]
                        },
                        {
                          label: "学历",
                          prop: "education",
                          type: 'select',
                          dataType: 'number',
                          props: {
                            label: 'dictValue',
                            value: 'dictKey',
                          },
                          dicUrl: '/api/blade-system/dict/dictionaryWithIntKey?code=logistics_personnel_education',
                          rules: [{
                            required: true,
                            message: "请选择",
                            trigger: "change"
                          }]
                        },
                        {
                          label: "职称",
                          prop: "jobTitle",
                          maxlength: 30,
                          showWordLimit: true,
                          overHidden: true,
                          rules: [{
                              required: true,
                              message: "请输入职称",
                              trigger: "change"
                          }]
                        },
                        {
                          label: "调入日期",
                          prop: "hireDate",
                          type: 'date',
                          format: 'yyyy-MM-dd',
                          valueFormat: 'yyyy-MM-dd',
                          rules: [{
                              required: true,
                              message: "请输入调入日期",
                              trigger: "change"
                          }]
                        },
                        {
                          label: "状态",
                          prop: "workStatus",
                          search:true,
                          searchSpan:5,
                          type: 'select',
                          dataType: 'number',
                          props: {
                            label: 'dictValue',
                            value: 'dictKey',
                          },
                          dicUrl: '/api/blade-system/dict/dictionaryWithIntKey?code=logistics_personal_workStatus',
                          rules: [{
                            required: true,
                            message: "请选择",
                            trigger: "change"
                          }]
                        },
                        {
                          label: "离岗日期",
                          prop: "leaveDate",
                          display:false,
                          type: 'date',
                          format: 'yyyy-MM-dd',
                          valueFormat: 'yyyy-MM-dd',
                        },
                        {
                          label: '附件上传',
                          prop: 'fileAttach',
                          formslot: true,
                          disable: false,
                          hide: true,
                          span: 24,
                        },
                        {
                          label: "备注说明",
                          prop: "description",
                          type:'textarea',
                          maxlength: 100,
                          showWordLimit: true,
                          overHidden: true,
                          hide: true,
                          span: 24,
                        },
                    ]
                },
                data: [],
                firstProjectId: false,
                oldProjectId: '',
                disabled: false,
                searchForm:{

                },
            };
        },
      watch: {
        'query.projectId'(){
          this.oldProjectId = this.query.projectId
        },
        "form.workStatus"(){
          if (this.form.workStatus == 2) {
            this.option.column[12].display = true;
          }else{
            this.option.column[12].display = false;
            this.form.leaveDate = '';
          }
        },
      },
      mounted(){
        window.onresize = ()=>{
          this.$refs.crud.$refs.table.doLayout()
        }
      },
      created(){
        getProjectList().then((res)=>{
          this.projectList = res.data;
          this.query.projectId = res.data[0].id;
          this.searchForm.projectId = res.data[0].id;
          this.firstProjectId = true;
          this.onLoad();
          this.getDeptList(this.query.projectId)
          /*getDeptList({projectId:this.query.projectId}).then(({ data }) => {
            this.findObject(
              this.option.column,
              'departmentId'
            ).dicData = data;
          });*/
          this.firstDisplayFlag = true;
        })
      },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
        methods: {
          projectChange(value){
            this.query.projectId = value;
            this.query.departmentId = '';
            this.getDeptList(value)
          },
          projectChange_(value){
            this.form.projectId = value;
            this.form.departmentId = '';
            this.getDeptList(value)
          },
          getProjectNameById(projectId) {
            let projectName = '';
            this.projectList.forEach(function (value, index, array) {
              if (value.id === projectId) {
                projectName = value.name;
                return;
              }
            });
            return projectName;
          },
          async getDeptList(value) {
            this.deptNameFlag = false;
            await treeByProjectDeptId({ projectId: value }).then((res) => {
              // this.searchForm.deptList = res.data;
              this.deptList = res.data;
              // console.log(this.searchForm.deptList)
            });
            this.deptNameFlag = true;
          },
            rowSave(row, done, loading) {
            console.log("form>>>>>>>",this.form);
                add(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowUpdate(row, index, done, loading) {
                update(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowDel(row) {
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: row.id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
            handleDelete() {
                if (this.selectionList.length === 0) {
                    this.$message.warning("请选择至少一条数据");
                    return;
                }
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: this.ids});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                        this.$refs.crud.toggleSelection();
                    });
            },
            async beforeOpen(done, type) {
            this.form.fileAttach  = [];
              if(type == "view"){
                this.editMode = true;
                this.disabled = true;
                let projectId = this.form.projectId;
                await getDetail({id:this.form.id}).then(({data}) => {
                  this.form = data;
                });
                await this.getDeptList(projectId);
                this.deptNameFlag = false;
                this.$forceUpdate()
              }
              if (["edit"].includes(type)) {
                this.disabled = false;
                this.editMode = false;
                this.deptNameFlag = true;
                let projectId = this.form.projectId;
                getDetail({id:this.form.id}).then(({data}) => {
                  this.form = data;
                });
                await this.getDeptList(projectId);
                this.deptNameFlag = true;
              }

              if (["add"].includes(type)) {
                this.disabled = false;
                this.editMode = false;
                this.deptNameFlag = true;
                let projectId = this.query.projectId;
                this.form.projectId = this.query.projectId;
                this.form.id = '';
                this.form.departmentId = '';
                await this.getDeptList(projectId);
                this.form.post = '';
                this.form.name = '';
                this.form.birthday = '';
                this.form.sex = '';
                this.form.education = '';
                this.form.jobTitle = '';
                this.form.hireDate = '';
                this.form.leaveDate = '';
                this.form.workStatus = 1;
                this.form.description = '';
              }
                done();
            },
            searchReset() {
              setTimeout(()=>{
                this.query.projectId = this.oldProjectId;
                this.query.departmentId = '';
                this.query.name = '';
                this.query.workStatus = '';
                this.onLoad();
              },0)
            },
            searchChange(params, done) {
                // this.query = Object.assign({},this.query,params);
                /*if(!this.query.projectId){
                  this.query.projectId = this.oldProjectId;
                }*/
                this.query.name = params.name
                this.query.workStatus = params.workStatus
                this.page.currentPage = 1;
                this.onLoad();
                done();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
            onLoad(page) {
              if (!this.firstProjectId) {
                return ;
              }else{
                this.query.projectId?this.query.projectId : this.projectList[0].id;
              }
                page = page || this.page;
                this.loading = true;
                getList(
                    Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
            ).then(({data}) => {
                    this.page.total = data.total;
                    this.data = data.records;
                    this.loading = false;
                    this.selectionClear();
                    this.form.workStatus = 1;
                  if (this.firstDisplayFlag) {
                    // let ent = document.querySelector('input[placeholder="项目名称"]');
                    // ent.value = this.getProjectNameById(this.query.projectId);
                    this.oldProjectId = this.query.projectId
                    //关闭默认显示，重刷页面时才开启默认显示
                    this.firstDisplayFlag = false;
                  }
                });
            }
        }
    };
</script>

<style>
</style>
